<template>
  <Select
    :items="etapas"
    :selectedItem="filter.etapa"
    label="Etapa"
    searchPlaceholder="Buscar etapa"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        etapa: {
          id: "",
          name: "",
        },
      },
      etapas: this.filtro.opcoes || [],
    };
  },
  methods: {
    atualizar(etapa) {
      this.filter.etapa = etapa;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.etapa.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.etapa.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.etapas, this.filter.etapa);
  }
}
</script>
